export default class {
  /**
   * 显示修改框
   */
  setValueStyle () {
    let labelW = parseInt(this.labelStyle.split(';')[0].split(':')[1])
    let separateW = parseInt(this.$refs.separate.offsetWidth)
    this.$refs.value.style = 'width:calc( 100% - ' + (labelW + separateW + 2) + 'px)'
  }
}
